// Toast deck — bottom-right, auto-dismissing, undo-friendly.
// Per spec §18.2.

import { useEffect } from 'react';
import { CheckCircle, AlertTriangle, AlertOctagon, Info } from 'lucide-react';
import { useStudio, type Toast as ToastT } from '../lib/store';

const ICONS = {
  default: Info,
  success: CheckCircle,
  warn: AlertTriangle,
  error: AlertOctagon,
};

export function ToastDeck() {
  const toasts = useStudio((s) => s.toasts);
  const dismiss = useStudio((s) => s.dismissToast);
  return (
    <div className="toast-deck" role="status" aria-live="polite">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onDismiss }: { toast: ToastT; onDismiss: () => void }) {
  const Icon = ICONS[toast.type];
  useEffect(() => {
    const id = setTimeout(onDismiss, 2600);
    return () => clearTimeout(id);
  }, [onDismiss]);
  return (
    <div className={`toast toast--${toast.type}`}>
      <Icon size={18} aria-hidden="true" strokeWidth={1.6} />
      <span className="toast__msg">{toast.message}</span>
      {toast.action && (
        <button
          type="button"
          className="toast__action"
          onClick={() => {
            toast.action?.onClick();
            onDismiss();
          }}
        >
          {toast.action.label}
        </button>
      )}
    </div>
  );
}
